module.exports = __webpack_public_path__ + "img/gloginlogo.0fa3fe04.png";